/** Fallback when site_settings.site_public_title is empty (matches backend default). */
export const DEFAULT_PUBLIC_DOCUMENT_TITLE =
  "Invincible NGO | India's Largest Trekking Organization";

let cachedPublicDocumentTitle = DEFAULT_PUBLIC_DOCUMENT_TITLE;

export function cachePublicDocumentTitle(title) {
  const t = String(title ?? '').trim();
  if (t) cachedPublicDocumentTitle = t;
}

export function getCachedPublicDocumentTitle() {
  return cachedPublicDocumentTitle;
}
